import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import searches from '../../../../../../utils/routing/searches'
import { capitalize } from '../../../../../../utils/string'
import educationRecs from '../../static/EducationRecommendations.json'
import careerRecs from '../static/CareerRecommendations.json'

class Recommendations extends Component {
  static propTypes = {
    handleFormSubmit: PropTypes.func.isRequired,
    recType: PropTypes.oneOf(['career', 'education']),
  }

  constructor(props) {
    super(props)
    this.onCareerSuggestionSelected = () => {
      this.props.handleFormSubmit()
    }
  }

  render() {
    let { recType } = this.props
    let recs = recType === 'career' ? careerRecs : educationRecs

    return (
      <div>
        <h2 style={{ marginBottom: '10px' }}>Don't Know Where to Start?</h2>
        <h4>
          Explore {recType === 'career' ? 'Careers' : 'Majors'} for {new Date().getFullYear()}
        </h4>
        <div className="row" style={{ marginTop: '35px' }}>
          {recs.categories.map(category => (
            <div className="col-md-3 text-center mb-4" key={category.categoryName}>
              {category.categoryName}:&nbsp;
              {category.data.slice(0, 8).map(rec => (
                <div
                  key={rec}
                  onClick={() => this.onCareerSuggestionSelected(rec)}
                  className="mt-2"
                >
                  <Link
                    to={searches.buildUrlForSearchType({
                      searchType: recType,
                      searchParams: {
                        search_query: rec,
                      },
                    })}
                  >
                    <i className="fal fa-search" />
                    &nbsp;
                    {capitalize(rec)}
                  </Link>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default Recommendations



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/Career/components/Recommendations.js